<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">

    <div class="modal-header">
        <h4 class="modal-title" id="standard-modalLabel">{{ 'customField.edit.title' | translate }}</h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true" (click)="close()"></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup" class="w-100 col-lg-8">
        <div class="row">
          <div class="col-12 mb-3">
            <label class="form-label">{{ 'customField.edit.nameLabel' | translate }}</label>
            <input
              formControlName="name"
              class="form-control"
              [placeholder]="'customField.edit.namePlaceholder' | translate"
              maxlength="100" />
            <field-error-component [field]="'name'" [label]="'customField.edit.nameFieldLabel' | translate" [formGroup]="formGroup" />
          </div>

          <div class="col-12 mb-3">
            <label class="form-label">{{ 'customField.edit.typeLabel' | translate }}</label>
            <select formControlName="type" class="form-select">
              @for (item of listTypeField; track $index) {
              <option [value]="item">{{ item === 'TEXT' ? ('customField.edit.typeText' | translate) : item === 'NUMBER' ? ('customField.edit.typeNumber' | translate) : item ===
                'FREETEXT' ? ('customField.edit.typeFreeText' | translate) : item === 'DATE' ? ('customField.edit.typeDate' | translate) : '-' }}</option>
              }
            </select>
            <field-error-component [field]="'type'" [label]="'customField.edit.typeFieldLabel' | translate" [formGroup]="formGroup" />
          </div>

          <div class="col-12 mb-3">
            <label class="form-label">{{ 'customField.edit.scopeLabel' | translate }}</label>
            <select formControlName="scope" class="form-select">
              @for (scope of scopes; track scope.value) {
                <option [value]="scope.value">{{ scope.label | translate }}</option>
              }
            </select>
            @if (!isNew) {
              <small class="text-muted">{{ 'customField.edit.scopeLocked' | translate }}</small>
            }
          </div>

          <div class="col-12 mb-3">
            <label class="form-label">{{ 'customField.edit.descriptionLabel' | translate }}</label>
            <textarea
              [rows]="3"
              [cols]="50"
              class="form-control"
              formControlName="description"
              [placeholder]="'customField.edit.descriptionPlaceholder' | translate">
            </textarea>
            <small
              class="text-muted"
            >
              {{ 'customField.edit.descriptionHelp' | translate }}
            </small>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()">
        {{ 'customField.edit.cancel' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [mat-dialog-close]="true"
        [disabled]="!formGroup.valid"
        (click)="save()"
      >
        {{ 'customField.edit.save' | translate }}
        @if (loading) {
          <mat-spinner
            [diameter]="25"
            [color]="'accent'"
            mode="indeterminate"
          />
        }
      </button>
    </div>

  </div>
</div>
